function isCalendlyEvent(e) {
  return e.origin === "https://calendly.com" && e.data.event && e.data.event.indexOf("calendly.") === 0
}

window.addEventListener("message", function(e) {
	if(isCalendlyEvent(e)) {
		switch (e.data.event) {
			case 'calendly.event_type_viewed': // Event type page was viewed
				gtag('event', 'invitee_event_type_page')
				break
			case 'calendly.date_and_time_selected': // Invitee selected date and time
				gtag('event', 'invitee_select_time')
				break
			case 'calendly.event_scheduled': // Invitee successfully booked a meeting
				gtag('event', 'invitee_meeting_scheduled') // google analytics event
				gtag('event', 'conversion', {
					'send_to': 'AW-10889153399/2ISECJqXsOoZEPeWrcgo',
					'value': 1.0,
					'currency': 'USD',
				})
		}
	}
})
